import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import RhinoConfirm from '../../../common/confirm/RhinoConfirm';

import * as financeActionCreators from '../../../../actions/finance';
let allActionCreators = Object.assign({}, financeActionCreators);


class FinancePlanRow extends React.Component {

  constructor(props) {
    super(props);
    this.state = {

      inputPlanId: this.props.plan ? this.props.plan.plan_id : '',
      inputTerm: this.props.plan ? this.props.plan.term : '',
      inputApr: this.props.plan ? this.props.plan.apr : '',
      inputCost: this.props.plan ? this.props.plan.cost : '',

      errorPlanId: '',
      errorTerm: '',
      errorApr: '',
      errorCost: '',

      editing: !this.props.plan,
      deleteConfirmOpen: false,

      requestPending: false,
    };

    this.controller = null;
  }

  componentWillUnmount() {
    if(this.controller) {
      this.controller.abort();
    }
  }

  changePlanId(evt) {
    this.setState({ inputPlanId: evt.target.value }, () => {
      if(this.state.errorPlanId) {
        this.validatePlanId();
      }
    });
  }

  validatePlanId() {
    this.setState({ errorPlanId: this.state.inputPlanId === '' ? 'error' : '' });
  }

  changeTerm(evt) {
    this.setState({ inputTerm: evt.target.value }, () => {
      if(this.state.errorTerm) {
        this.validateTerm();
      }
    });
  }

  validateTerm() {
    this.setState({ errorTerm: this.state.inputTerm === '' ? 'error' : '' });
  }

  changeApr(evt) {
    this.setState({ inputApr: evt.target.value }, () => {
      if(this.state.errorApr) {
        this.validateApr();
      }
    });
  }

  validateApr() {
    this.setState({ errorApr: this.state.inputApr === '' ? 'error' : '' });
  }

  changeCost(evt) {
    this.setState({ inputCost: evt.target.value }, () => {
      if(this.state.errorCost) {
        this.validateCost();
      }
    });
  }

  validateCost() {
    this.setState({ errorCost: this.state.inputCost === '' ? 'error' : '' });
  }

  validateAll() {
    const errorObj = {
      errorPlanId: this.state.inputPlanId === '' ? 'error' : '',
      errorTerm: this.state.inputTerm === '' ? 'error' : '',
      errorApr: this.state.inputApr === '' ? 'error' : '',
      errorCost: this.state.inputCost === '' ? 'error' : '',
    };
    this.setState(errorObj);
    for(const key in errorObj) {
      if(errorObj[key]) {
        return false;
      }
    }
    return true;
  }

  async saveAction() {
    if(this.validateAll()) {
      
      if(this.controller) {
        this.controller.abort();
      }
      const controller = new AbortController();
      this.controller = controller;

      this.setState({
        requestPending: true,
      });

      const saveReq = {
        plan_id: this.state.inputPlanId,
        term: this.state.inputTerm,
        apr: this.state.inputApr,
        cost: this.state.inputCost,
      };

      if(this.props.plan) {

        saveReq['id'] = this.props.plan.id;

        await this.props.financeEditPlan(saveReq, controller.signal)
          .catch((errResp) => {
            if(controller.signal.aborted) { return null; }
            console.error(errResp);
            this.setState({ 
              requestPending: false,
            });
          });
      } else {      
        await this.props.financeCreatePlan(saveReq, controller.signal)
          .catch((errResp) => {
            if(controller.signal.aborted) { return null; }
            console.error(errResp);
            this.setState({ 
              requestPending: false,
            });
          });
      }

      this.closeEdit();
      await this.props.makeClean();

      this.setState({
        requestPending: false,
      });
    }
  }

  openEdit() {
    this.setState({ editing: true });
  }

  closeEdit() {
    if(this.props.parentClose) {
      this.props.parentClose();
    } else {
      this.setState({ editing: false });
    }
  }

  promptDelete() {
    this.setState({ deleteConfirmOpen: true });
  }

  async confirmDelete() {

    if(!this.props.plan) { return null; }

    this.setState({
      requestPending: true,
    });

    const deleteReq = {
      id: this.props.plan.id,
    };

    await this.props.financeDeletePlan(deleteReq)
      .catch((errResp) => {
        console.error(errResp);
        this.setState({ 
          requestPending: false,
        });
      });

    await this.props.makeClean();

    this.setState({
      requestPending: false,
    }, () => {
      this.cancelDelete();
    });
  }

  cancelDelete() {
    this.setState({ deleteConfirmOpen: false });
  }
    
  render() {
    return <div className='FinancePlanRow'>
      <div className='tableRow'>
        <div className={'idCell bodyCell'}>
          {this.state.editing ?
            <div className='bodyInput'>
              <input
                type='text'
                className={`inlineInput ${this.state.errorPlanId ? 'error' : ''}`}
                placeholder='1234'
                value={this.state.inputPlanId}
                onChange={this.changePlanId.bind(this)}
                onBlur={this.validatePlanId.bind(this)} />
            </div> :
            <div className='bodyValue'>{this.props.plan ? this.props.plan.plan_id : ''}</div>
          }
        </div>
        <div className={'termCell bodyCell'}>
          {this.state.editing ?
            <div className='bodyInput'>
              <input
                type='text'
                className={`inlineInput ${this.state.errorTerm ? 'error' : ''}`}
                placeholder='36'
                value={this.state.inputTerm}
                onChange={this.changeTerm.bind(this)}
                onBlur={this.validateTerm.bind(this)} />
            </div> :
            <div className='bodyValue'>{this.props.plan ? `${this.props.plan.term} ${this.props.width > 768 ? 'months' : ''}` : ''}</div>
          }
        </div>
        <div className={'aprCell bodyCell'}>
          {this.state.editing ?
            <div className='bodyInput'>
              <input
                type='text'
                className={`inlineInput ${this.state.errorApr ? 'error' : ''}`}
                placeholder='4.99'
                value={this.state.inputApr}
                onChange={this.changeApr.bind(this)}
                onBlur={this.validateApr.bind(this)} />
              <div className='percentOverlay'>%</div>
            </div> :
            <div className='bodyValue'>{this.props.plan ? `${this.props.plan.apr}%` : ''}</div>
          }
        </div>
        <div className={'costCell bodyCell'}>
          {this.state.editing ?
            <div className='bodyInput'>
              <input
                type='text'
                className={`inlineInput ${this.state.errorCost ? 'error' : ''}`}
                placeholder='1.99'
                value={this.state.inputCost}
                onChange={this.changeCost.bind(this)}
                onBlur={this.validateCost.bind(this)} />
              <div className='percentOverlay'>%</div>
            </div> :
            <div className='bodyValue'>{this.props.plan ? `${this.props.plan.cost}%` : ''}</div>
          }
        </div>
        <div className={`actionCell bodyCell ${this.state.editing ? 'editing' : ''}`}>
          {this.state.editing ?
            <div className='bodyValue'>
              <div className={`bodyAction ${this.state.requestPending ? 'pending' : ''}`} onClick={this.saveAction.bind(this)}>{this.state.requestPending ? 'Saving' : 'Save'}</div>
              <div className='bodyCancel' onClick={this.closeEdit.bind(this)}>&times;</div>
            </div> :
            <div className='bodyValue'>
              <div className='bodyAction' onClick={this.openEdit.bind(this)}>Edit</div>
              <div className='bodyCancel' onClick={this.promptDelete.bind(this)}>&times;</div>
            </div>
          }
        </div>
        {this.state.requestPending ?
          <div className='loadingScreen'></div> :
          null
        }
      </div>
      <RhinoConfirm
        confirmTitle='Delete?'
        confirmText='Are you sure you want to remove this plan?'
        confirmMethod={this.confirmDelete.bind(this)}
        cancelMethod={this.cancelDelete.bind(this)}
        open={this.state.deleteConfirmOpen} />
    </div>;
  }
}
export default FinancePlanRow;

function mapStateToProps(state) {
  return {
    common: state.common,
  };
}

export const FinancePlanRowContainer = connect(
  mapStateToProps,
  allActionCreators
)(FinancePlanRow);